module.exports = __webpack_public_path__ + "img/5.5c4e95df.png";